import jsPDF from "jspdf";
import moment from "moment";
import certificateImage from "../../assets/img/certificate_template.jpg";
import cat2CertificateImage from "../../assets/img/certificate_template_cat2.jpg";
import {TrainerService} from "../Trainers/trainers.service";
import {TraineeService} from "./trainees.service";

export const generateCertificate1 = async (
    traineeUpdateCourse,
    userInfo,
    imageSrc
) => {
    const doc = new jsPDF({
        orientation: "landscape",
        filters: ["ASCIIHexEncode"],
    });
    let logoUrl = traineeUpdateCourse?.program?.cpdProvider?.logo_url || "";
    let stampUrl = traineeUpdateCourse?.program?.cpdProvider?.stamp_url || "";
    let signature1Url = traineeUpdateCourse?.program?.cpdProvider?.signature1_url || "";
    let signature2Url = traineeUpdateCourse?.program?.cpdProvider?.signature2_url || "";
    // let signature3Url = traineeUpdateCourse?.program?.cpdProvider?.signature3_url || "";

    // to get the extension of the logo
    const lastDotIndex = logoUrl ? logoUrl.lastIndexOf(".") : -1;
    let extension = "";
    if (lastDotIndex !== -1) {
        extension = logoUrl.substring(lastDotIndex + 1).toLowerCase();

        switch (extension) {
            case "jpg":
            case "jpeg":
                extension = "JPEG";
                break;
            case "png":
                extension = "PNG";
                break;
            default:
                extension = "";
                break;
        }
    }

    // to get the extension of the stamp
    const lastStampDotIndex = stampUrl ? stampUrl.lastIndexOf(".") : -1;
    let stampExtension = "";
    if (lastStampDotIndex !== -1) {
        stampExtension = stampUrl.substring(lastStampDotIndex + 1).toLowerCase();

        switch (stampExtension) {
            case "jpg":
            case "jpeg":
                stampExtension = "JPEG";
                break;
            case "png":
                stampExtension = "PNG";
                break;
            default:
                stampExtension = "";
                break;
        }
    }

    // to get the extension of the signatures
    const lastSign1DotIndex = signature1Url ? signature1Url.lastIndexOf(".") : -1;
    let sign1Extension = "";
    if (lastSign1DotIndex !== -1) {
        sign1Extension = signature1Url.substring(lastSign1DotIndex + 1).toLowerCase();

        switch (sign1Extension) {
            case "jpg":
            case "jpeg":
                sign1Extension = "JPEG";
                break;
            case "png":
                sign1Extension = "PNG";
                break;
            default:
                sign1Extension = "";
                break;
        }
    }
    const lastSign2DotIndex = signature2Url ? signature2Url.lastIndexOf(".") : -1;
    let sign2Extension = "";
    if (lastSign2DotIndex !== -1) {
        sign2Extension = signature2Url.substring(lastSign2DotIndex + 1).toLowerCase();

        switch (sign2Extension) {
            case "jpg":
            case "jpeg":
                sign2Extension = "JPEG";
                break;
            case "png":
                sign2Extension = "PNG";
                break;
            default:
                sign2Extension = "";
                break;
        }
    }
    // const lastSign3DotIndex = signature3Url ? signature3Url.lastIndexOf(".") : -1;
    // let sign3Extension = "";
    // if (lastSign3DotIndex !== -1) {
    //   sign3Extension = signature3Url.substring(lastSign3DotIndex + 1).toLowerCase();
    //
    //   switch (sign3Extension) {
    //     case "jpg":
    //     case "jpeg":
    //       sign3Extension = "JPEG";
    //       break;
    //     case "png":
    //       sign3Extension = "PNG";
    //       break;
    //     default:
    //       sign3Extension = "";
    //       break;
    //   }
    // }
    console.log("traineeUpdateCourse", traineeUpdateCourse);

    if (traineeUpdateCourse?.program?.category?.categoryType === "CAT1")
        doc.addImage(certificateImage, "JPEG", 0, 0, 298, 213, undefined, "FAST");
    else
        doc.addImage(cat2CertificateImage, "JPEG", 0, 0, 298, 213, undefined, "FAST");



    if (logoUrl != "") {
        const logoResp = await TrainerService.getImage({url: logoUrl});
        const logoImage =
            logoResp && logoResp.data && logoResp.data.data ? logoResp.data.data : "";
        doc.addImage(logoImage, extension, 138, 30, 25, 25);
    }
    if (stampUrl != "") {
        const stampResp = await TrainerService.getImage({url: stampUrl});
        const stampImage =
            stampResp && stampResp.data && stampResp.data.data ? stampResp.data.data : "";
        // doc.addImage(stampImage, stampExtension, 30, 20, 25, 25);
        doc.addImage(stampImage, stampExtension, 120, 155, 30, 30);
    }
    if (signature1Url != "") {
        const sign1Resp = await TrainerService.getImage({url: signature1Url});
        const sign1Image =
            sign1Resp && sign1Resp.data && sign1Resp.data.data ? sign1Resp.data.data : "";

        doc.addImage(sign1Image, sign1Extension, 30, 155, 20, 20);
    }
    if (signature2Url != "") {
        const sign2Resp = await TrainerService.getImage({url: signature2Url});
        const sign2Image =
            sign2Resp && sign2Resp.data && sign2Resp.data.data ? sign2Resp.data.data : "";

        // doc.addImage(sign2Image, sign2Extension, 120, 155, 20, 20);
        doc.addImage(sign2Image, sign2Extension, 220, 155, 20, 20);
    }
    // if (signature3Url != "") {
    //   const sign3Resp = await TrainerService.getImage({ url: signature3Url });
    //   const sign3Image =
    //     sign3Resp && sign3Resp.data && sign3Resp.data.data ? sign3Resp.data.data : "";
    //
    //   doc.addImage(sign3Image, sign3Extension, 220, 155, 20, 20);
    // }

    doc.setTextColor("#B68646");
    let pageWidth = doc.internal.pageSize.getWidth();
    doc.setFont;
    doc.text(
        pageWidth / 2 -
        (traineeUpdateCourse && traineeUpdateCourse.program
            ? doc.getTextWidth(
                traineeUpdateCourse?.program?.cpdProvider?.trainingCenterName
            ) /
            2 +
            13
            : traineeUpdateCourse && traineeUpdateCourse.course
                ? doc.getTextWidth(
                    traineeUpdateCourse?.course?.courseOwner?.trainingCenterName
                ) /
                2 +
                13
                : 0),
        68,
        `${
            traineeUpdateCourse && traineeUpdateCourse.program
                ? traineeUpdateCourse?.program?.cpdProvider?.trainingCenterName.toUpperCase()
                : traineeUpdateCourse && traineeUpdateCourse.course
                    ? traineeUpdateCourse?.course?.courseOwner?.trainingCenterName.toUpperCase()
                    : "-"
        }`
    );
    var certificateReason = traineeUpdateCourse.certificate_reason
        ? traineeUpdateCourse.certificate_reason.name
        : "-";

    doc.setTextColor("#B68646");

    doc.setTextColor("black");
    doc.setFontSize(15);
    doc.setTextColor("black");
    doc.setFontSize(15);

    doc.text(
        175,
        89,
        `${
            userInfo.trainee && userInfo.trainee.prefix
                ? userInfo.trainee.prefix
                : userInfo.person && userInfo.person.prefix
                    ? userInfo.person.prefix
                    : "-"
        }`
    );
    userInfo.trainee
        ? doc.text(
            120,
            102,
            `${userInfo.trainee.firstName ? userInfo.trainee.firstName : "-"} ${
                userInfo.trainee.middleName && userInfo.trainee.middleName
            } ${userInfo.trainee.lastName && userInfo.trainee.lastName}`
        )
        : doc.text(
            120,
            102,
            `${userInfo.person.firstname ? userInfo.person.firstname : "-"} ${
                userInfo.person.middlename && userInfo.person.middlename
            } ${userInfo.person.lastname && userInfo.person.lastname}`
        );
    doc.setFontSize(12);
    doc.text(120, 114, `Has ${certificateReason}`);
    doc.setFontSize(15);

    doc.text(
        pageWidth / 2 -
        (traineeUpdateCourse.course
            ? doc.getTextWidth(traineeUpdateCourse.course.courseName) / 2
            : doc.getTextWidth(traineeUpdateCourse.program.courseTitleCat2) / 2),
        122,
        `${
            traineeUpdateCourse.course
                ? traineeUpdateCourse.course.courseName
                : traineeUpdateCourse.program.courseTitleCat2
                    ? traineeUpdateCourse.program.courseTitleCat2
                    : "-"
        }`
    );
    doc.setFontSize(12);
    doc.text(
        65,
        135,
        `${traineeUpdateCourse?.course?.courseCode ?? ''}`
    );
    doc.text(
        65,
        143,
        `${
            traineeUpdateCourse.course
                ? traineeUpdateCourse.course.continualEducationUnit
                : traineeUpdateCourse.program
                    ? traineeUpdateCourse.program.ceu
                    : "-"
        }`
    );
    doc.text(
        80,
        150.3,
        `${
            traineeUpdateCourse.courseCompletionDate
                ? moment(traineeUpdateCourse.courseCompletionDate).format(
                    "MMM DD, YYYY"
                )
                : "-"
        }`
    );

    doc.text(
        208,
        135.5,
        `${traineeUpdateCourse?.course?.courseAccreditor?.accreditorName ?? ''}`
    );

    doc.text(
        220,
        143,
        `${
            traineeUpdateCourse?.course?.courseLevel?.name ?? traineeUpdateCourse?.program?.courseLevel?.name ?? ''}`
    );

    doc.text(
        185,
        150.5,
        `${
            traineeUpdateCourse.program
                ? traineeUpdateCourse.program.startDate
                    ? traineeUpdateCourse.program.startDate
                ?? new Date()
                    : "-"
                : "-"
        }`
    );

    doc.text(
        235,
        150.5,
        `${
            traineeUpdateCourse.program
                ? traineeUpdateCourse.program.endDate
                    ? traineeUpdateCourse.program.endDate
                ?? new Date()
                    : "-"
                : "-"
        }`
    );

    doc.setFontSize(15);
    doc.text(
        40,
        193,
        `${traineeUpdateCourse?.program?.collaborator ?
            'Collaborator\'s Names: ' : ""}`
    );

    doc.setFontSize(12);
    doc.text(
        93,
        193,
        `${traineeUpdateCourse?.program?.collaborator ?? ""}`
    );
    doc.addImage(imageSrc, "JPG", 235, 14, 35, 35);
    window.open(doc.output("bloburl"));

    //send email
    try {
        const pdfBlob = doc.output("blob");
        const formData = new FormData();
        formData.append('file', pdfBlob, 'certificate.pdf');
            const name = userInfo?.trainee?(`${userInfo?.trainee?.firstName} ${userInfo?.trainee?.middleName} ${userInfo?.trainee?.lastName}`):
                (userInfo?.person?(`${userInfo?.person?.firstname} ${userInfo?.person?.middlename} ${userInfo?.person?.lastname}`):'');
            const email = userInfo?.trainee?userInfo?.facilityEmail ?? userInfo?.trainee?.email:userInfo?.person?.email;
            const course = traineeUpdateCourse?.course?.courseName ?? traineeUpdateCourse?.program?.courseTitleCat2;
            const cpd = traineeUpdateCourse?.program?.cpdProvider?.trainingCenterName ?? traineeUpdateCourse?.course?.courseOwner?.trainingCenterName;
        formData.append('name', name);
        formData.append('email', email);
        formData.append('course', course);
        formData.append('cpd', cpd);
        await TraineeService.sendEmail(formData);
    }catch (e) {
        console.log(e)
    }
};
